module.exports = __webpack_public_path__ + "img/5. CoPA.e59f57e0.jpg";